module.exports = __webpack_public_path__ + "static/HeliosRed-1aefb087a05ae5f78dd0d5cb69545be2.jpg";